import React from 'react';

const UserStories = () => {
  return (
<table className='table table-border table-hover border '>
        <tbody>
        <tr>
      <th>Name</th>
      <th>Age</th>
      <th>Education</th>
      <th>Gender</th>
      <th>Occupation</th>
      <th>City</th>
      <th>Country</th>
      <th>User Story</th>
      <th>Goals</th>
      <th>Frustrations</th>
      <th>Suggestion</th>
      <th>Expectation</th>
    </tr>
    <tr>
      <td>Neelakandan Subbiah Pillai</td>
      <td>28</td>
      <td>Postgraduate</td>
      <td>Male</td>
      <td>Designer</td>
      <td>Trivandrum</td>
      <td>India</td>
      <td>As a fashion enthusiast, I love exploring the latest trends on the fashion website and sharing my thoughts on new collections and styles.</td>
      <td>My goal is to find unique and stylish clothing items that align with my personal fashion preferences.</td>
      <td>I get frustrated when the website has slow loading times, making it challenging to browse through products seamlessly.</td>
      <td>I would appreciate a more intuitive navigation system to easily locate specific categories and filter options.</td>
      <td>I expect the website to provide a visually appealing and user-friendly experience, making my online shopping journey enjoyable.</td>
    </tr>
    <tr>
      <td>Anna Johnson</td>
      <td>32</td>
      <td>Graduate</td>
      <td>Female</td>
      <td>Marketing Professional</td>
      <td>New York City</td>
      <td>United States</td>
      <td>Exploring the fashion website for the latest trends and unique pieces to enhance my professional appearance.</td>
      <td>My goal is to discover versatile outfits suitable for both work meetings and casual outings.</td>
      <td>Frustrated when the website lacks detailed product descriptions, making it hard to understand the fabric and fit.</td>
      <td>Suggest providing size guides and detailed product information for a better online shopping experience.</td>
      <td>Expect the website to offer a seamless shopping experience with quick delivery and easy returns.</td>
    </tr>

    <tr>
      <td>Mohammed Ali</td>
      <td>25</td>
      <td>Undergraduate</td>
      <td>Male</td>
      <td>Software Engineer</td>
      <td>Bengaluru</td>
      <td>India</td>
      <td>Looking for trendy and comfortable clothing options to wear during casual outings and weekend activities.</td>
      <td>My goal is to build a stylish and versatile wardrobe without compromising on comfort.</td>
      <td>Frustrated when the website's checkout process is complicated and time-consuming.</td>
      <td>Suggest optimizing the checkout flow for a smoother and faster transaction experience.</td>
      <td>Expect the website to offer a variety of payment options and timely order updates.</td>
    </tr>
    <tr>
        <td>Sophie Turner</td>
        <td>24</td>
        <td>Graduate</td>
        <td>Female</td>
        <td>Content Creator</td>
        <td>Los Angeles</td>
        <td>United States</td>
        <td>As a content creator, I explore the fashion website for unique and photogenic outfits to feature in my social media content.</td>
        <td>My goal is to discover fashion pieces that resonate with my personal style and engage my followers.</td>
        <td>Frustrated when the website lacks a variety of sizes and styles for petite individuals.</td>
        <td>Suggest expanding the size range and providing a dedicated section for petite clothing.</td>
        <td>Expect the website to prioritize inclusivity and offer a diverse range of fashion options.</td>
</tr>
<tr>
  <td>Rahul Patel</td>
  <td>30</td>
  <td>Postgraduate</td>
  <td>Male</td>
  <td>Financial Analyst</td>
  <td>Mumbai</td>
  <td>India</td>
  <td>Searching for formal and business-casual attire on the fashion website to enhance my professional wardrobe.</td>
  <td>My goal is to find high-quality clothing suitable for corporate meetings and presentations.</td>
  <td>Frustrated when the website lacks detailed product images, making it challenging to assess fabric and design.</td>
  <td>Suggest providing multiple high-resolution images from different angles for each product.</td>
  <td>Expect the website to offer a sophisticated collection of formal wear and efficient customer support.</td>
</tr>

<tr>
  <td>Lily Chen</td>
  <td>26</td>
  <td>Undergraduate</td>
  <td>Female</td>
  <td>Student</td>
  <td>Beijing</td>
  <td>China</td>
  <td>Exploring the fashion website to find affordable and stylish clothing options for daily wear as a student.</td>
  <td>My goal is to stay on trend within a limited budget and showcase my personal style on campus.</td>
  <td>Frustrated when the website lacks clear information on shipping costs and delivery times.</td>
  <td>Suggest providing transparent shipping details during the checkout process.</td>
  <td>Expect the website to offer budget-friendly fashion with transparent and upfront shipping information.</td>
</tr>

        </tbody>
    </table>
  );
};

export default UserStories;
